module.exports = __webpack_public_path__ + "static/media/person-circle.d8ac1f9f.svg";